/* eslint-disable no-debugger */
import { Injectable } from '@angular/core';
import { ProtocolResponse } from '@/app/interfaces/protocol';
import { ProtocolDetailsResponse } from '../interfaces/protocol-details';
import { environment } from '@/environments/environment';
import axios from 'axios';
import { ToastService } from './script/toast.service';
import { LoaderService } from '@/app/services/interceptor/loader-service';
interface ApiResponse<T> {
  data: T;
}
@Injectable({
  providedIn: 'root',
})
export class ProtocolsService {
  private readonly apiUrl = '/api/aurora';

  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async getProtocols(params): Promise<ProtocolResponse> {
    try {
      this.loader.show();
      const payload = {
        filters: { params },
        list: 'protocols',
      };
      const response = await axios.post<ApiResponse<ProtocolResponse>>(
        `${environment.url}${this.apiUrl}/listado`,
        payload,
        { withCredentials: true }
      );
      return response.data.data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener los protocolos',
        error?.response?.data?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async getProtocolDetails(protocolId: number, detail: string): Promise<ProtocolDetailsResponse> {
    try {
      this.loader.show();
      if (!protocolId) {
        throw new Error('Protocol ID is required to fetch protocol details');
      }
      const response = await axios.post<ProtocolDetailsResponse>(
        `${environment.url}${this.apiUrl}/detalle`,
        { id_protocolo: protocolId, detail: detail },
        {
          withCredentials: true,
        }
      );
      return response.data;
    } catch (error) {
      this.toastService.showError(
        'Error al obtener el detalle del protocolo',
        error?.response?.data?.message || 'Ha ocurrido un error inesperado'
      );
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
